import React from 'react';
import styled from 'styled-components';
import SingleMeasureFilterRelOp from './SingleMeasureFilterRelOp';
import SingleMeasureFilterValues from '../SingleMeasureFilterValues';
import SingleMeasureFilterMeasureKey from './SingleMeasureFilterMeasureKey';
import { IconWrapper, SvgIcon } from '../../../../../../Icon';
import { borderedContent } from '../../../../../../../styles/shareableStyles';
import { SquareRemoveButton } from '../../../../../../Button';

interface IProps {
  filterIndex: number;
  onRemove?: () => void;
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 28px 240px 120px auto 24px;
  column-gap: 8px;
  padding: 12px 4px 12px 12px;
  ${borderedContent};
`;

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 28px;
  text-align: center;
`;

const ActionsWrapper = styled.div`
  margin-top: 2px;
`;

const SingleMeasureFilter = ({ filterIndex, onRemove }: IProps) => (
  <Container>
    <IconContainer>
      <IconWrapper>
        <SvgIcon name="measure-filter" width={16} height={16} isActive />
      </IconWrapper>
    </IconContainer>
    <SingleMeasureFilterMeasureKey filterIndex={filterIndex} />
    <SingleMeasureFilterRelOp filterIndex={filterIndex} />
    <SingleMeasureFilterValues filterIndex={filterIndex} />
    <ActionsWrapper>
      {onRemove && (
        <SquareRemoveButton onClick={onRemove} content={'Remove Filter'} />
      )}
    </ActionsWrapper>
  </Container>
);

export default SingleMeasureFilter;
